<template>
  <svg
    :class="{
      'text-www-color-accent': true,
    }"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5_1031)">
      <path
        d="M2.99833 2.24854H14.9917C15.8191 2.24854 16.4908 2.92029 16.4908 3.7477V11.2435C16.4908 12.0709 15.8191 12.7427 14.9917 12.7427H2.99833C2.17091 12.7427 1.49916 12.0709 1.49916 11.2435V3.7477C1.49916 2.92029 2.17091 2.24854 2.99833 2.24854V2.24854"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.99667 15.741H11.9933M8.99501 12.7427V15.741"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1031">
        <rect
          width="17.99"
          height="17.99"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
